<!--<div class="d-flex justify-content-center text-center mt-5">-->
<!--  <div class="spinner-border" role="status">-->
<!--    <span class="sr-only">Loading...</span>-->
<!--  </div>-->
<!--</div>-->

<div *ngIf="overlay" class="ic1-overlay ic1-overlay-spinner">
  <div class="spinner row flex-nowrap justify-content-center align-self-center" style="width: auto !important; height: auto !important">
    <div class="bounce1" style="width:30px; height:30px; background-color: #0072CE"></div>
    <div class="bounce2" style="width:30px; height:30px; background-color: #0072CE"></div>
    <div class="bounce3" style="width:30px; height:30px; background-color: #0072CE"></div>
    
  </div>
</div>
<div *ngIf="loading">
  <div class="spinner row flex-nowrap justify-content-center align-self-center" style="margin: 0; width: auto !important; height: auto !important">
    <div class="bounce1" style="width:30px; height:30px; background-color: #0072CE"></div>
    <div class="bounce2" style="width:30px; height:30px; background-color: #0072CE"></div>
    <div class="bounce3" style="width:30px; height:30px; background-color: #0072CE"></div>
  </div>
</div>
<div *ngIf="!overlay && !loading" class="main-spinner">
  <div class="spinner row flex-nowrap justify-content-center align-self-center" style="width: 80%; height: 80%">
    <div class="bounce1" style="width:30px; height:30px; background-color: #0072CE"></div>
    <div class="bounce2" style="width:30px; height:30px; background-color: #0072CE"></div>
    <div class="bounce3" style="width:30px; height:30px; background-color: #0072CE"></div>
  </div>
</div>
